Vue.component('thread-list', require('./components/thread/ThreadList.vue').default);

//Vue.component('generic-list', require('./components/generic/GenericList.vue').default);
Vue.component('generic-show', require('./components/generic/GenericShow.vue').default);
Vue.component('generic-edit', require('./components/generic/GenericEdit.vue').default);
Vue.component('list-filter', require('./components/generic/ListFilter.vue').default);
Vue.component('inline-filter', require('./components/generic/InlineFilter.vue').default);


Vue.component('user-list', require('./components/user/UserList.vue').default);
Vue.component('user-show', require('./components/user/UserShow.vue').default);
Vue.component('user-edit', require('./components/user/UserEdit.vue').default);

Vue.component('staff-list', require('./components/user/UserList.vue').default);
Vue.component('staff-show', require('./components/user/UserShow.vue').default);
Vue.component('staff-edit', require('./components/user/UserEdit.vue').default);

Vue.component('patient-list', require('./components/user/UserList.vue').default);
Vue.component('patient-show', require('./components/user/UserShow.vue').default);
Vue.component('patient-edit', require('./components/user/UserEdit.vue').default);

Vue.component('presetmessage-list', require('./components/presetmessage/PresetMessageList.vue').default);
Vue.component('presetmessage-show', require('./components/presetmessage/PresetMessageShow.vue').default);
Vue.component('presetmessage-edit', require('./components/presetmessage/PresetMessageEdit.vue').default);

Vue.component('usergroup-list', require('./components/usergroup/UserGroupList.vue').default);
Vue.component('usergroup-show', require('./components/usergroup/UserGroupShow.vue').default);
Vue.component('usergroup-edit', require('./components/usergroup/UserGroupEdit.vue').default);

Vue.component('autocomplete', require('vuejs-auto-complete'));

Vue.component('availability-edit', require('./components/generic/AvailabilityEdit.vue').default);
Vue.component('custom-action-selector', require('./components/generic/CustomActionSelector.vue').default);

Vue.component('userduplicate-list', require('./components/userduplicate/UserDuplicateList.vue').default);
Vue.component('userduplicate-show', require('./components/userduplicate/UserDuplicateShow.vue').default);
Vue.component('userduplicate-edit', require('./components/userduplicate/UserDuplicateEdit.vue').default);

Vue.component('news-list', require('./components/news/NewsList.vue').default);
Vue.component('news-show', require('./components/news/NewsShow.vue').default);
Vue.component('news-edit', require('./components/news/NewsEdit.vue').default);

Vue.component('log-list', require('./components/log/LogList.vue').default);
Vue.component('log-show', require('./components/log/LogShow.vue').default);


Vue.component('feedback-list', require('./components/feedback/FeedbackList.vue').default);
Vue.component('feedback-show', require('./components/feedback/FeedbackShow.vue').default);


Vue.component('provider-list', require('./components/provider/ProviderList.vue').default);
Vue.component('provider-show', require('./components/provider/ProviderShow.vue').default);
Vue.component('provider-edit', require('./components/provider/ProviderEdit.vue').default);


Vue.component('message-list', require('./components/message/MessageList.vue').default);

Vue.component('navigation', require('./components/AppNavigation.vue').default);
Vue.component('patient-top-nav', require('./components/PatientTopNav.vue').default);
Vue.component('global-message', require('./components/GlobalMessage.vue').default);
Vue.component('notification', require('./components/Notification.vue').default);
Vue.component('inline-error', require('./components/InlineError.vue').default);
Vue.component('local-error', require('./components/LocalError.vue').default);

Vue.component('navbar', require('./components/NavBar.vue').default);
Vue.component('navname', require('./components/NavName.vue').default);

Vue.component('loading', require('./components/Loading.vue').default);

Vue.component('gruveo', require('./components/Gruveo.vue').default);

Vue.component('password', require('./components/Password.vue').default);
Vue.component('password-strength-info', require('./components/PasswordStrengthInfo.vue').default);

//Vue.component('pagination', require('laravel-vue-pagination').default);

Vue.component('paginator', require('./components/Paginator.vue').default);

Vue.component('assign', require('./components/thread/Assign.vue').default);
Vue.component('copy-dialog', require('./components/thread/CopyDialog.vue').default);
Vue.component('set-wait', require('./components/thread/SetWait.vue').default);
Vue.component('email-verification', require('./components/generic/auth/EmailVerification.vue').default);
Vue.component('password-verification', require('./components/generic/auth/PasswordVerification.vue').default);
Vue.component('priority-flags', require('./components/thread/PriorityFlags.vue').default);
Vue.component('related-thread-list', require('./components/thread/RelatedThreadList.vue').default);
Vue.component('compact-message-list', require('./components/message/CompactMessageList.vue').default);
Vue.component('preset-message-select', require('./components/message/PresetMessageSelect.vue').default);
Vue.component('form-select', require('./components/message/FormSelect.vue').default);
Vue.component('form-submission', require('./components/forms/FormSubmission.vue').default);

Vue.component('admin-navigation', require('./components/admin/AppNavigation.vue').default);
Vue.component('admin-navbar', require('./components/admin/NavBar.vue').default);

Vue.component('vue-dob-picker', require('./components/vue-dob-picker.vue').default);

Vue.component('autocomplete2', require('./components/generic/Autocomplete.vue').default);

Vue.component('datetime2', require('./components/DateTime.vue').default);

Vue.component('coding', require('./components/Coding.vue').default);
Vue.component('coding-list', require('./components/CodingList.vue').default);

Vue.component('blood-pressure', require('./components/BloodPressure.vue').default);
Vue.component('blood-pressure-list', require('./components/BloodPressureList.vue').default);

Vue.component('component-filter', require('./components/ComponentFilter.vue').default);
Vue.component('component-filter-list', require('./components/ComponentFilterList.vue').default);


Vue.component('blood-pressure-range', require('./components/BloodPressureRange.vue').default);
Vue.component('blood-pressure-range-list', require('./components/BloodPressureRangeList.vue').default);

Vue.component('thread-code-edit', require('./components/thread/ThreadCodeEdit.vue').default);

Vue.component('daterange', require('./components/DateRange.vue').default);

Vue.component('appointment-session-type-table', require('./components/appointment/AppointmentSessionTypeTable.vue').default);
Vue.component('appointment-session-type', require('./components/appointment/AppointmentSessionType.vue').default);
Vue.component('appointment-session-table', require('./components/appointment/AppointmentSessionTable.vue').default);
Vue.component('appointment-session', require('./components/appointment/AppointmentSession.vue').default);

Vue.component('thread', require('./components/thread/Thread.vue').default);

Vue.component('test-component', require('./components/test-component.vue').default);

// Vue.component('requests-by-source', require('./components/reports/RequestsBySource.vue').default);
// Vue.component('requests-by-resolution', require('./components/reports/RequestsByResolution.vue').default);

Vue.component('smsp-search-dialog', require('./components/SmspSearchDialog.vue').default);

Vue.component('search-dialog', require('./components/SearchDialog.vue').default);

Vue.component('full-image-dialog', require('./components/FullImageDialog.vue').default);
Vue.component('document-download-dialog', require('./components/DocumentDownloadDialog.vue').default);
Vue.component('attachment-display', require('./components/AttachmentDisplay.vue').default);


Vue.component('notification-button', require('./components/NotificationButton.vue').default);

Vue.component('install-button', require('./components/InstallButton.vue').default);

Vue.component('calendar', require('./components/bookings/provider/Calendar.vue').default);
Vue.component('appointment-booking-select', require('./components/bookings/provider/AppointmentBookingSelect.vue').default);
Vue.component('patient-booking', require('./components/bookings/patient/Booking.vue').default);
Vue.component('edit-appointment', require('./components/bookings/provider/EditAppointment.vue').default);

Vue.component('unread-threads', require('./components/patient/UnreadThreads.vue').default);
Vue.component('appointments', require('./components/patient/Appointments.vue').default);
Vue.component('message-appointment', require('./components/message/MessageAppointment.vue').default);

Vue.component('patient-banner', require('./components/message/PatientBanner.vue').default);

Vue.component('list-base-template', require('./components/base/ListBaseTemplate.vue').default);
Vue.component('show-base-template', require('./components/base/ShowBaseTemplate.vue').default);
Vue.component('edit-base-template', require('./components/base/EditBaseTemplate.vue').default);